"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useMatchMedia = _interopRequireDefault(require("../_use-match-media"));

/**
 * This operates similar to useCallback, except that the callback will wait to
 *
 * @param {string} breakpoint - The breakpoint to compare the browser's width to.
 *   E.g. "500px"
 * @param {('smaller'|'larger')} [fallback] - The value to fallback to on initial
 *   mount. Useful for server-side rendering.
 * @returns {('smaller'|'larger')} - A string describing if the browser's width
 *   is "smaller" or "larger" than the breakpoint. NOTICE: when the browser's
 *   width is equal to the breakpoint "smaller" will be returned.
 */
var useBreakpoint = function useBreakpoint(breakpoint, fallback) {
  var smaller = (0, _useMatchMedia["default"])({
    condition: "max",
    feature: "width",
    breakpoint: breakpoint,
    fallback: fallback === "smaller" ? breakpoint : fallback === "larger" ? breakpoint - 1 : undefined
  });
  return smaller ? "smaller" : "larger";
};

var _default = useBreakpoint;
exports["default"] = _default;